import React from 'react';

import emotionStyled from '@emotion/styled';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  padding-left: 9px;
`;

const LineMakerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const VerticalLine = emotionStyled.div`
  height: ${(props) => (props.$isLast ? '50%' : '100%')};
  border-left: 1px solid ${(props) => props.theme.colors.text.g3};
  position: absolute;
  top: 0;
  left: ${(props) => `${props.$leftMultiplier * 23.5 + (props.$leftMultiplier - 1) * 13}px`};
`;

const LShapeDiv = emotionStyled.div`
  flex: 0 0 auto;
  height: 0px;
  margin-left: ${(props) => `${(props.$parentDepth - 1) * 28}px`};
  width: 28px;
  border-left: 1px solid ${(props) => props.theme.colors.text.g3};
  border-bottom: 1px solid ${(props) => props.theme.colors.text.g3};
`;

const LevelUpAnalyticsLineMaker = ({
  isLast = false,
  parentDepth = 0,
  isExpanded = false,
  isParentLastRow = false,
  levelsForWhichLineToBeDrawn = [],
}) => (
  <LineMakerContainer>
    <LShapeDiv $parentDepth={parentDepth} />
    {new Array(parentDepth).fill('ln').map((_, index) => {
      if (levelsForWhichLineToBeDrawn[index] === false) {
        return null;
      }
      return (
        <VerticalLine
          $isLast={index < parentDepth - 1 ? false : isLast}
          $leftMultiplier={index + 1}
          $isExpanded={isExpanded}
          className="vertical-line"
        />
      );
    })}
  </LineMakerContainer>
);

export default LevelUpAnalyticsLineMaker;
